export const assessmentTemplate = [
  {
    _id: "0004",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-07T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "ad8",
      omniTypeVersion: 1,
      title: "AD8 Dementia Screening Interview",
      description: "",
      duration: "About 10 minutes",
      directions:
        "For each question, please select the answer that most closely applies to the patient.",
      attribution:
        "Copyright 2005. The AD8 is a copyrighted instrument of the Alzheimer’s Disease Research Center, Washington University, St. Louis, Missouri. All Rights Reserved.",
      validated: true,
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "AD81",
          numberText: "1",
          text: "Problems with judgment",
          subText:
            "e.g., problems making decisions, bad financial decisions, problems with thinking",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD82",
          numberText: "2",
          text: "Less interest in hobbies/activities",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD83",
          numberText: "3",
          text: "Repeats the same things over and over",
          subText: "questions, stories, or statements",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD84",
          numberText: "4",
          text: "Trouble learning how to use a tool, appliance, or gadget",
          subText: "e.g., VCR, computer, microwave, remote control",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD85",
          numberText: "5",
          text: "Forgets correct month or year",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD86",
          numberText: "6",
          text: "Trouble handling complicated financial affairs",
          subText: "e.g., balancing checkbook, income taxes, paying bills",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD87",
          numberText: "7",
          text: "Trouble remembering appointments",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "AD88",
          numberText: "8",
          text: "<b>Daily</b> problems with thinking and/or memory",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Remember, “Yes, a change” indicates that there has been a change in the last several years caused by cognitive (thinking and memory) problems.",
          answerOptions: [
            {
              value: "1",
              text: "YES, A change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "0",
              text: "NO, No change",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "00",
              text: "N/A, Don't know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "ad8",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 5,
        formula: null,
        questions: [],
      },
    ],
  },
];
